module.exports = __webpack_public_path__ + "assets/img/33.c0e7205b.png";